'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var reactDropzone = require('react-dropzone');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Container = styled.div.withConfig({
  componentId: "sc-1ir36se-0"
})(function (_ref) {
  var sDefault = _ref.sDefault,
    sDragOver = _ref.sDragOver,
    sHover = _ref.sHover;
  return _objectSpread(_objectSpread(_objectSpread({}, sDefault), sDragOver && sDragOver), {}, {
    '&:hover': _objectSpread({}, sHover)
  });
});
var baseStyle = {
  paddingLeft: '1.25rem',
  paddingRight: '1.25rem',
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
  borderWidth: '2px',
  borderStyle: 'dashed',
  borderColor: '#e6e6e6',
  backgroundColor: '#fafafa',
  color: '#a3a3a3'
};
var baseDragOverStyle = {
  borderColor: '#cacaca',
  backgroundColor: '#ececec'
};
var FileUpload = function FileUpload(_ref2) {
  var accept = _ref2.accept,
    children = _ref2.children,
    disabled = _ref2.disabled,
    maxSize = _ref2.maxSize,
    multiple = _ref2.multiple,
    _onDrop = _ref2.onDrop,
    sDefault = _ref2.sDefault,
    sDragOver = _ref2.sDragOver,
    sHover = _ref2.sHover;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDragOver = _React$useState2[0],
    setDragOver = _React$useState2[1];
  // eslint-disable-next-line @typescript-eslint/unbound-method
  var _useDropzone = reactDropzone.useDropzone({
      accept: accept,
      disabled: disabled,
      maxSize: maxSize,
      multiple: multiple,
      onDragEnter: function onDragEnter() {
        return setDragOver(true);
      },
      onDragLeave: function onDragLeave() {
        return setDragOver(false);
      },
      onDrop: function onDrop(acceptedFiles, rejectedFiles, event) {
        setDragOver(false);
        _onDrop(acceptedFiles, rejectedFiles, event);
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  return /*#__PURE__*/React.createElement(Container, _extends({}, getRootProps(), {
    sDefault: _objectSpread(_objectSpread({}, baseStyle), sDefault && sDefault),
    sDragOver: _objectSpread({}, isDragOver && _objectSpread(_objectSpread({}, baseDragOverStyle), sDragOver)),
    sHover: _objectSpread({
      cursor: disabled ? 'not-allowed' : 'pointer'
    }, sHover),
    role: "form"
  }), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    "data-testid": "fileupload-input"
  })), children);
};
FileUpload.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string.isRequired)]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  maxSize: PropTypes.number,
  multiple: PropTypes.bool,
  onDrop: PropTypes.func.isRequired,
  sDefault: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
  sDragOver: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
  sHover: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired)
};
FileUpload.defaultProps = {
  accept: ['.jpg', '.jpeg', '.png'],
  children: undefined,
  disabled: false,
  maxSize: undefined,
  multiple: false,
  sDefault: undefined,
  sDragOver: undefined,
  sHover: undefined
};

exports.default = FileUpload;
